/**
 * @see https://www.typescriptlang.org/docs/handbook/mixins.html
 */
export function applyMixins(derivedCtor) {
  for (var _len = arguments.length, baseCtors = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    baseCtors[_key - 1] = arguments[_key];
  }
  baseCtors.forEach(baseCtor => {
    Object.getOwnPropertyNames(baseCtor.prototype).forEach(name => {
      if (name !== 'constructor') {
        Object.defineProperty(derivedCtor.prototype, name, Object.getOwnPropertyDescriptor(baseCtor.prototype, name));
      }
    });
  });
}